import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardResolver } from './dashboard.resolver';
import { DashboardComponent } from './dashboard.component';
@NgModule({
    imports: [RouterModule.forChild([
        {
            path: '',
            children: [
                { path: '', resolve: { prefetch: DashboardResolver }, component: DashboardComponent },
            ],
        },
    ])],
    exports: [RouterModule],
})
export class DashboardRoutingModule {
}
